import { handle } from 'src/shared-utilities/async-helpers/promise-helpers';
import { Borrower } from '../../../shared/models/deal-resources/borrower.model';
import { ClientJourneyContext } from '../../../shared/services/deal/client-journey-context';
import {
  DeleteResourceCommand,
  PostResourceCommand,
  ResourceCommand,
} from '../../../shared/services/resource-command-stream.service';
import { ValidationGlobalStore } from '../../../../../utilities/validation/validation-global-store';
import { BorrowerValidator } from './borrower.validator';
import { ClientJourneyValidatorStoreBase } from '../../../shared/validation/client-journey-validator-store-base';
import { SlidesStateNames } from '../../../router/slides-states';

export class BorrowersValidatorStore extends ClientJourneyValidatorStoreBase {
  static readonly globalStoreKey = 'BorrowersValidationStore';

  private commandStreamEventDetach: () => void;

  constructor(
    globalStore: ValidationGlobalStore,
    clientJourneyContext: ClientJourneyContext,
  ) {
    super(globalStore, clientJourneyContext, SlidesStateNames.Borrowers);

    // Create a validator for each borrower
    clientJourneyContext.deal.borrowers.forEach(b =>
      this.getBorrowerValidator(b),
    );

    // Hook the command stream to be notified of new or removed borrowers
    this.commandStreamEventDetach =
      clientJourneyContext.resourceCommandStream.onCommandSuccess(command =>
        this.onCommandSuccess(command),
      );
  }

  override dispose() {
    super.dispose();
    this.commandStreamEventDetach();
  }

  private async onCommandSuccess(command: ResourceCommand) {
    // Post uses Partial<T> for command.resource, so we can't rely on that
    // to get the borrower, but we can use the result of the command.
    // Delete will return a http response object for the result, so we can't
    // rely on that to get the borrower, but we can use the command.resource.
    let [result, err] = await handle(command.result);
    if (!result || err) return;

    if (command instanceof PostResourceCommand && result instanceof Borrower) {
      this.getBorrowerValidator(result);
    }

    if (
      command instanceof DeleteResourceCommand &&
      command.resource &&
      command.resource instanceof Borrower
    ) {
      this.removeBorrowerValidator(command.resource);
    }
  }

  private getBorrowerKey(borrower: Borrower): string {
    let key = `borrower_${borrower.id}`;
    return key;
  }

  getBorrowerValidator(borrower: Borrower): BorrowerValidator {
    let key = this.getBorrowerKey(borrower);
    let validator = this.getValidator(key);
    if (!validator) {
      validator = new BorrowerValidator(borrower);
      this.addValidator(key, validator);
    }
    return validator as BorrowerValidator;
  }

  removeBorrowerValidator(borrower: Borrower) {
    let key = this.getBorrowerKey(borrower);
    this.removeValidator(key);
  }
}
